module.exports = __webpack_public_path__ + "static/media/inventario.4aa9b07a.svg";